import Parse from 'parse'
import {ParseDbService, albumSchema as Schema} from "./parse.db.service";

function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.AlbumClassName);

    if(pagination){
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }
    query.withCount(true);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.title, search);
    }

    return query.find().then(items => {
        return {
            results: items.results.map(item => {
                return {
                    parseItem: item,
                    title: item.get(Schema.title),
                    tracks: item.get(Schema.tracks)
                }
            }),
            count: items.count
        }
    });
}


function add(item) {
    let Album = Parse.Object.extend(ParseDbService.AlbumClassName, null, null);
    let albumObj = new Album();
    albumObj.set(Schema.title, item.title.toLowerCase());
    albumObj.set(Schema.tracks, parseInt(item.tracks));
    return albumObj.save();
}

function edit(item) {
    let albumObj = item.parseItem;
    albumObj.set(Schema.title,item.title.toLowerCase());
    albumObj.set(Schema.tracks, parseInt(item.tracks));
    return albumObj.save();
}

export const AlbumService = {
    getAll,
    add,
    edit
};
